/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"convert-file-formats": require("./convert-file-formats"),
	"section-try-for-free": require("../../section-try-for-free/en/section-try-for-free.json"),
};
